import { useEffect, useState } from 'react'

import { hasServiceWorker, prefetchMedia } from '../lib/mediaPrefetch'

/**
 * Warms the service worker's media cache with `urls` (lib/mediaPrefetch.js)
 * and says when that is done. The player waits for it with
 * `preload="metadata"` and then switches to `preload="auto"`, so the file
 * comes over the network once — the player's own ranges are then read from
 * the cache. Without a service worker there is nothing to warm: the player
 * preloads at once.
 */
export function useMediaPrefetch(urls) {
  const key = urls.filter(Boolean).join('\n')
  const [warm, setWarm] = useState(() => !hasServiceWorker())
  useEffect(() => {
    if (!hasServiceWorker() || !key) {
      setWarm(true)
      return undefined
    }
    let live = true
    setWarm(false)
    void Promise.all(key.split('\n').map((url) => prefetchMedia(url))).then(() => {
      if (live) setWarm(true)
    })
    return () => {
      live = false
    }
  }, [key])
  return warm
}
